






























































































import Vue from "vue";
import { Component, Prop, Watch } from "vue-property-decorator";
import { State, Action, Getter } from "vuex-class";
import { Utilities as utils } from "@/shared/utilities";
import { AppConstants as _app } from "@/shared/app.constants";
import ReportTable from './Components/ReportTable.vue';
import GrantPeriodEditor from './Components/GrantPeriodEditor.vue';
import DateComponent from "@/components/common/Inputs/Date.vue";
import { GrantData, GrantAmendmentData } from "@/entities";
import AmendmentSummary from './Summary.vue';

const namespace: string = "grantAmendment";

@Component({
    components: {
        ReportTable,
        GrantPeriodEditor,
        DateComponent,
        AmendmentSummary
    },
})
export default class NoCostExtension extends Vue {
    @State(namespace) grantAmendment!: GrantAmendmentData;
    @Prop() GrantInfo: any;
    @Prop() GrantData: any;
    @Prop() data: any;
    @Prop() readOnly: boolean;
    @Prop() userType?: number;
    auditor= _app.UserType.Auditor;
    leadPartner = _app.UserType.LeadPartner;
    editDialog: boolean = false;
    update = 0;

    mounted() {
        if (!this.grantAmendment.grantAmendment.RevisedEndDate) {
            this.grantAmendment.grantAmendment.RevisedEndDate = this.GrantInfo.ExpectedEndDate || this.GrantInfo.EndDate;
            this.update + 1;
        }
    }

    get startDate() {
        return this.GrantInfo.ActualStartDate || this.GrantInfo.StartDate;
    }

    finPeriods() {
        if (!this.grantAmendment.grantAmendmentDetailData.financialReportingPeriods) {
            if (this.GrantData.financialReportingPeriods) {
                this.grantAmendment.grantAmendmentDetailData.financialReportingPeriods = this.GrantData.financialReportingPeriods;
            } else {
                this.grantAmendment.grantAmendmentDetailData.financialReportingPeriods = [{}];
            }
        }
        return this.grantAmendment.grantAmendmentDetailData.financialReportingPeriods;
    }

    techPeriods() {
        if (!this.grantAmendment.grantAmendmentDetailData.techReportingPeriods) {
            if (this.GrantData.techReportingPeriods) {
                this.grantAmendment.grantAmendmentDetailData.techReportingPeriods = this.GrantData.techReportingPeriods;
            } else {
                this.grantAmendment.grantAmendmentDetailData.techReportingPeriods = [{}];
            }
        }
        return this.grantAmendment.grantAmendmentDetailData.techReportingPeriods;
    }

    /** edit the period */
    editPeriod() {
        this.editDialog = true;
    }
    closeDialog() {
        this.editDialog = false;
    }
    updatePeriod() {
    }

    getDueDate() {
        if (this.grantAmendment.grantAmendment.RevisedEndDate) {
            const newDate = new Date(this.grantAmendment.grantAmendment.RevisedEndDate);
            newDate.setMonth(newDate.getMonth() + 1);
            this.grantAmendment.grantAmendmentDetailData.projectDueDate = newDate;
            return newDate;
        }
    }
}
